import React, { useEffect, useState } from "react";
import SideBarHeader from "../InternalSidebar/SideBarHeader";
import LayoutHOC from "../LayoutHOC";
import SpecificDashboard from "../Groups/SpecificDashboard";

const SpecificCustomer = () => {
  const [currentHash, setCurrentHash] = useState(window.location.hash.split("?")[0]);
  // const [currentHashId, setCurrentHashId] = useState(window.location.hash.split("?")[1]);

  useEffect(() => {
    const handleHashChange = () => {
      const cleanHash = window.location.hash.split("?")[0];
      // const cleanHashId = window.location.hash.split("?")[1];
      // setCurrentHashId(cleanHashId);
      setCurrentHash(cleanHash);
    };
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const renderContent = (dashboard) => {
    // const cleanHash = currentHash.replace("#", "");
    const cleanHash = dashboard;
    switch (cleanHash) {
      case "dashboard":
        return <SpecificDashboard />;
      case "tracking":
        return <h1>Tracking Content</h1>;
      case "notes":
        return <h1>Notes Content</h1>;
      case "documents":
        return <h1>Documents Content</h1>;
      default:
        return;
    }
  };
  return (
    <div className="p-2 mb-0 flex h-full w-full overflow-x-auto">
      {/* <SideBarHeader /> */}

      <div className="flex-grow px-2">{renderContent("dashboard")}</div>
    </div>
  );
};

export default LayoutHOC(SpecificCustomer);
